var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CEESAR-ModelTable',{attrs:{"title":"Categories","label":"Category","model":"category","fileRoute":"categories/file"}})}
var staticRenderFns = []

export { render, staticRenderFns }